import {
  GetStockAllowance,
  UserStockItemAllowanceSummary,
  ConsumptionTableAllRecordType,
} from '@shared/entity';

export function createStockAllowancesTableByProductByUser(
  stockAllowances: GetStockAllowance[],
  keyExtractor: (item: GetStockAllowance) => string,
): UserStockItemAllowanceSummary[] {
  const summaryMap: Record<string, UserStockItemAllowanceSummary> = {};

  stockAllowances.forEach(stockAllowance => {
    const key = keyExtractor(stockAllowance);
    const quantity = Number(stockAllowance.quantity);
    const price = Number(stockAllowance.costs);
    if (summaryMap[key]) {
      summaryMap[key].totalQuantity += quantity;
      summaryMap[key].totalPrice += price;
    } else {
      summaryMap[key] = {
        id: key,
        user: stockAllowance.user.name,
        stockItemName: stockAllowance.stockItemName,
        unit: stockAllowance.stockItem.unit,
        totalQuantity: quantity,
        type: stockAllowance.type,
        totalPrice: price,
      };
    }
  });
  return Object.values(summaryMap);
}

export const createStockAllowancesTableAllRecords = (
  stockAllowances: GetStockAllowance[],
): ConsumptionTableAllRecordType[] => {
  return stockAllowances.map(stockAllowance => {
    return {
      id: stockAllowance.id,
      stockItemName: stockAllowance.stockItemName,
      totalPrice: Number(stockAllowance.costs),
      stockAllowanceQuantity: Number(stockAllowance.quantity),
      unit: stockAllowance.stockItem.unit,
      user: stockAllowance.user.name,
      type: stockAllowance.type,
      date: stockAllowance.createdAt,
      visitDate: stockAllowance.procedure.visit.date,
      visitId: stockAllowance.procedure.visitId,
      clientId: stockAllowance.procedure.visit.clientId,
    };
  });
};
